export const login_routes = {

  // auth routes routes

  login: "/login",
  register2: "/register-2",
  forgotPassword: "/forgot-password",
  twoStepVerification: "/two-step-verification",
  emailVerification: "/email-verification",
  lockScreen: "/lock-screen",
  resetPassword: "/reset-password",
  resetPasswordSuccess: "/reset-password-success",
  adminDashboard: "/index",

};
